import { client } from "./client";

const endpoint = "risk/";

// Global Limits
const getGlobalLimits = () => client(endpoint + "global-limits/");
const updateGlobalLimit = (id, data) =>
    client(endpoint + "global-limits/" + id + "/", { body: data, method: "PUT" });
const createGlobalLimit = (data) =>
    client(endpoint + "global-limits/", { body: data });
const deleteGlobalLimit = (id) =>
    client(endpoint + "global-limits/" + id + "/", { method: "DELETE" });

// Exposure Limits
const getExposureLimits = (targetLevel) => {
    let url = endpoint + "exposure-limits/";
    if (targetLevel) url += `?target_level=${targetLevel}`;
    return client(url);
};
const updateExposureLimit = (id, data) =>
    client(endpoint + "exposure-limits/" + id + "/", { body: data, method: "PUT" });
const createExposureLimit = (data) =>
    client(endpoint + "exposure-limits/", { body: data });
const deleteExposureLimit = (id) =>
    client(endpoint + "exposure-limits/" + id + "/", { method: "DELETE" });

// Number Overrides (Koupe Boul)
const getNumberOverrides = () => client(endpoint + "number-overrides/");
const createNumberOverride = (data) =>
    client(endpoint + "number-overrides/", { body: data });
const updateNumberOverride = (id, data) =>
    client(endpoint + "number-overrides/" + id + "/", { body: data, method: "PUT" });
const deleteNumberOverride = (id) =>
    client(endpoint + "number-overrides/" + id + "/", { method: "DELETE" });

export default {
    getGlobalLimits, updateGlobalLimit, createGlobalLimit, deleteGlobalLimit,
    getExposureLimits, updateExposureLimit, createExposureLimit, deleteExposureLimit,
    getNumberOverrides, createNumberOverride, updateNumberOverride, deleteNumberOverride,
};
